import { ReceiptContainerModel, ReceiptContainerModelExpectBackend, TemplateExpectBackend } from 'shared';
import { UnknownError, UUID } from 'symbols';

export class GetTrafficById {
  static type = '[trafficList] GetTrafficById';

  constructor(public id: UUID) {
  }
}

export class GetTrafficByIdSuccess {
  static type = '[trafficList] GetTrafficByIdSuccess';

  constructor(public traffic: ReceiptContainerModel) {
  }
}

export class GetTrafficByIdFail {
  static type = '[trafficList] GetTrafficByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentTrafficId {
  static type = '[trafficList] SetCurrentTrafficId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalTraffic {
  static type = '[trafficList] UpdateLocalTraffic';

  constructor(public traffic: ReceiptContainerModelExpectBackend) {
  }
}

export class DeleteLocalTraffic {
  static type = '[trafficList] DeleteLocalTraffic';

  constructor(public id: UUID) {
  }
}


export class UpdateTraffic {
  static type = '[trafficList] UpdateTraffic';

  constructor(public id: UUID, public traffic: ReceiptContainerModelExpectBackend, public force: boolean) {
  }
}

export class UpdateTrafficSuccess {
  static type = '[trafficList] UpdateTrafficSuccess';

  constructor(public traffic: ReceiptContainerModel) {
  }
}

export class UpdateTrafficFail {
  static type = '[trafficList] UpdateTrafficFail';

  constructor(public error: UnknownError) {
  }
}

export class CreateTraffic {
  static type = '[trafficList] CreateTraffic';

  constructor(public traffic: ReceiptContainerModelExpectBackend) {
  }
}

export class CreateTrafficSuccess {
  static type = '[trafficList] CreateTrafficSuccess';

  constructor(public traffic: ReceiptContainerModel) {
  }
}

export class CreateTrafficFail {
  static type = '[trafficList] CreateTrafficFail';

  constructor(public error: UnknownError) {
  }
}

export class CreatedTrafficByWS {
  static type = '[trafficList] CreatedTrafficByWS';

  constructor(public traffic: ReceiptContainerModel) {
  }
}

export class UpdatedTrafficByWS {
  static type = '[trafficList] UpdatedTrafficByWS';

  constructor(public traffic: ReceiptContainerModel) {
  }
}


export class CreateTrafficTemplate {
  static type = '[trafficList] CreateTrafficTemplate';

  constructor(public name: string, public template?: TemplateExpectBackend) {
  }
}

export class UpdateTrafficTemplate {
  static type = '[trafficList] UpdateTrafficTemplate';

  constructor(public template: { html?: string, project?: Object, formatId?: UUID, name: string, css: string }, public id: UUID) {
  }
}

export class DeleteTrafficTemplate {
  static type = '[trafficList] DeleteTrafficTemplate';

  constructor(public id: UUID) {
  }
}

export class UpdateTrafficTemplateSuccess {
  static type = '[trafficList] UpdateTrafficTemplateSuccess';
}

export class UpdateTrafficTemplateFail {
  static type = '[trafficList] UpdateTrafficTemplateFail';

  constructor(public error: UnknownError) {
  }
}

export class GetTrafficTemplateList {
  static readonly type = '[trafficList] GetTrafficTemplateList';
}
